import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from './api';
import './App.css';

// Define a simple User type for now
interface User {
  id: string;
  email: string;
  role: string;
}

const OrganizationUsersPage: FC = () => {
  const { orgId } = useParams<{ orgId: string }>();
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [inviteEmail, setInviteEmail] = useState('');
  const [newUserEmail, setNewUserEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchUsers = async () => {
    if (!orgId) return;
    try {
      const data = await api(`/organizations/${orgId}/users`);
      setUsers(data);
    } catch (err) {
      setError('Failed to fetch users.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [orgId]);

  const handleInviteSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      const newUser = await api(`/organizations/${orgId}/users`, {
        method: 'POST',
        body: JSON.stringify({ email: inviteEmail }),
      });
      setUsers([...users, newUser]);
      setInviteEmail('');
    } catch (err) {
      setError('Failed to invite user.');
    }
  };

  const handleAddUser = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      const newUser = await api(`/organizations/${orgId}/users`, {
        method: 'POST',
        body: JSON.stringify({ email: newUserEmail }),
      });
      setUsers([...users, newUser]);
      setNewUserEmail('');
    } catch (err) {
      setError('Failed to add user.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRemoveUser = async (userId: string) => {
    // Implement the logic to remove a user
  };

  if (loading) return <div className="loading">Loading users...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="page-container">
      <h1 className="page-title">Manage Organization Users</h1>
      
      <form onSubmit={handleInviteSubmit} className="invite-form" style={{ marginBottom: '2rem' }}>
        <h2>Invite New User</h2>
        <div className="form-group">
          <label htmlFor="email">User Email</label>
          <input
            type="email"
            id="email"
            value={inviteEmail}
            onChange={(e) => setInviteEmail(e.target.value)}
            placeholder="Enter email to invite"
            required
          />
        </div>
        <button type="submit" className="button-primary">Invite User</button>
      </form>

      <div className="user-list">
        {users.length > 0 ? (
          users.map(user => (
            <div key={user.id} className="user-list-item">
              <span>{user.email}</span>
              <span>{user.role}</span>
              {/* TODO: Add buttons for role change/removal */}
            </div>
          ))
        ) : (
          <p>No users found for this organization.</p>
        )}
      </div>
    </div>
  );
};

export default OrganizationUsersPage; 